import Scenario from "./Scenario";
import ArrayIterator from "/lib/html5-software-library/src/ranj/util/datastructures/array/ArrayIterator";

/**
* ScenarioLibrary.js
* 
* Created on 8-okt-2013, 11:55:31
*
* @author Ivo Swartjes for Ranj
**/
export default class ScenarioLibrary {
	constructor() {
        /** @type {Array<Scenario>} */
        this._scenarios = [];
        /** @type {Scenario} */
        this._currentScenario;
        /** @type {Scenario} */
        this._defaultScenario;
    }
    
    /**
     * 
     * @returns {Scenario}
     */
    getCurrentScenario() {
        return this._currentScenario;
    }
    
    /**
     * 
     * @param {Scenario} scenario 
     */
    setCurrentScenario(scenario) {
        this._currentScenario = scenario;
    }
    
    /**
     * 
     * @returns {Scenario}
     */
    getDefaultScenario() {
        return this._defaultScenario;
    }
    
    /**
     * 
     * @param {Scenario} scenario 
     */
    setDefaultScenario(scenario) {
        this._defaultScenario = scenario;
    }
    
    /**
     * 
     * @param {Scenario} scenario 
     */
    addScenario(scenario) {
        this._scenarios.push(scenario);
    }
    
    /**
     * 
     * @param {string} id 
     * @returns {Scenario | null}
     */
    getScenarioByID(id) {
        for (var i = 0; i < this._scenarios.length; i++) {
            var scenario = this._scenarios[i];
            if (scenario.id === id) {
                return scenario;
            }
        }
        
        return null;
    }

    /**
     * 
     * @returns {Array<Scenario>}
     */
    getScenarios() {
        return this._scenarios;
    }
    
    scenarioIterator() {
        return new ArrayIterator(this._scenarios);
    }

}


